import { memo } from 'react';
import { Circle, GeoJSON } from 'react-leaflet';

import { GEOMETRY_TYPE } from '../../constants/map';

import MapPopup from './MapPopup';
import { FILL_OPACITY, LINE_WEIGHT } from './constants';

function Shape({ item, isSelected = false, path }) {
  return item.geometry?.type === GEOMETRY_TYPE.POLYGON ? (
    <GeoJSON
      data={item}
      style={{
        fillOpacity: isSelected ? FILL_OPACITY.SELECTED : FILL_OPACITY.DEFAULT,
        color: item.color,
        weight: LINE_WEIGHT
      }}>
      <MapPopup description={item.properties.description} link={path} name={item.properties.name} />
    </GeoJSON>
  ) : (
    <Circle
      center={[item.geometry.coordinates[1], item.geometry.coordinates[0]]}
      color={item.color}
      fillColor={item.color}
      fillOpacity={isSelected ? FILL_OPACITY.SELECTED : FILL_OPACITY.DEFAULT}
      radius={!isNaN(item.properties.radius) ? item.properties.radius : 1}
      weight={LINE_WEIGHT}>
      <MapPopup description={item.properties.description} link={path} name={item.properties.name} />
    </Circle>
  );
}

export default memo(Shape);
